/**
 * BatchMatrixModeToggle - Expert Mode Toggle for Matrix Batch
 *
 * Purple-styled toggle to enable per-image configuration (Templates, Aspect Ratios, Seeds).
 */

import { Zap } from 'lucide-react';
import { Switch } from '@/components/v2/ui';

interface BatchMatrixModeToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

export function BatchMatrixModeToggle({
  enabled,
  onChange,
  disabled = false,
}: BatchMatrixModeToggleProps) {
  return (
    <div className="flex items-center gap-3 p-4 rounded-lg border border-primary-200 bg-primary-50 dark:border-primary-800 dark:bg-primary-950/30">
      <Zap className="h-5 w-5 text-primary-500" />
      <div className="flex-1">
        <h4 className="font-medium text-primary-900 dark:text-primary-100">Expert Mode</h4>
        <p className="text-sm text-primary-700 dark:text-primary-300">
          Granulare Kontrolle pro Bild (Templates, Aspect Ratios, Seeds)
        </p>
      </div>
      <Switch
        checked={enabled}
        onCheckedChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
